import gql from 'graphql-tag'

export default gql`
  query MultiSelectCourse {
    courses(perPage: 100) {
      nodes {
        id
        title
      }
    }
  }
`
